
<div>
    <f-image-preview
        v-model = "preview.show"
        :image  = "preview.image"
    />

    <f-image-upload
        :title            = "stamp.name"
        :image            = "image"
        :min-image-height = "minImageHeight"
        @drop             = "onDrop"
    >
        <template v-slot:additional>
            <div style="position: relative" class="lm-border pa-3 mt-2">
                <div class="v-flex upload-button">
                    <div>
                        <c-toolbar-button
                            class    = ""
                            size     = "24"
                            color    = "primary"
                            icon     = "mdi-image"
                            :tooltip = "$t('stamp.upload.text.image')"
                            @click   = "onPreview"
                        />
                    </div>
                    <div>
                        <c-toolbar-button
                            size     = "24"
                            color    = "primary"
                            icon     = "mdi-content-save-outline"
                            :tooltip = "$t('stamp.upload.text.save')"
                            @click   = "onSave"
                        />
                    </div>
                </div>

                <v-text-field
                    v-model = "stamp.name"
                    label="Bezeichnung"
                />

                <v-textarea
                    v-model = "stamp.lines"
                    label="Zusatztext"
                    rows    = "3"
                    class   = ""
                    hide-details
                    no-resize
                />

                <div class="v-flex">
                    <div class="w-50">
                        <v-switch
                            class="pt-0"
                            v-model="stamp.addSignature"
                            label="Mit Unterschrift"
                        />
                    </div>
                    <div class="w-50">
                        <v-switch
                            class="pt-0"
                            v-model="stamp.addName"
                            label="Mit Namen"
                            hide-details
                        />
                        <v-switch
                            class="pt-0 mt-2"
                            v-model="stamp.addDate"
                            label="Mit Datum"
                            hide-details
                        />
                    </div>
                </div>
            </div>

        </template>
    </f-image-upload>
</div>
